import apiFetch from '../apiFetch'

export default function (idProducto, leido, token) {
  return apiFetch({endPoint: `Producto/marcarNotificacionLeidaStock?idProducto=` + idProducto + `&leido=` + leido, method: 'GET', body: null, token: token})
}